import { Form, Input } from 'antd';
import Box from 'components/Box';
import Text from 'components/Text';
import React from 'react';
import styled from 'styled-components';
import { ChangeServiceModalRef, QuickBookingV2ServiceItemProps } from '../Service';
import CustomerServiceList from '../Service/CustomerServiceList';
import { ModalChangeTimeRef } from '../TimeDate';
import { IQuickBookingV2CustomerItem, IQuickBookingV2ServiceItem } from '../type';
import { IStaffItemData } from 'services/shop/types/staff';
import Edit from 'assets/Icons/edit';
import colorTheme from 'constants/color';
import CustomerSearchInput from './CustomerSearchInput';
import { ICustomerItemData } from 'services/shop/types/customer';
export type CustomerDataItemProps = {
  single?: boolean;
  value?: IQuickBookingV2CustomerItem;
  onChange?: (value: IQuickBookingV2CustomerItem) => void;
  name: any;
  index: number;
  changeServiceModalRef: React.RefObject<ChangeServiceModalRef>;
  onActiveService?: QuickBookingV2ServiceItemProps['onActiveService'];
  onOpenChangeStaff: QuickBookingV2ServiceItemProps['onOpenChangeStaff'];
  modalChangeTimeRef: React.RefObject<ModalChangeTimeRef>;
  staffs: IStaffItemData[];
  getListStaff: (serviceId: string, servicesProps?: IQuickBookingV2ServiceItem[]) => void;
  onEditName: (value?: IQuickBookingV2CustomerItem, onChange?: (value: IQuickBookingV2CustomerItem) => void) => void;
  onChangeCustomer?: (value?: IQuickBookingV2CustomerItem, oldData?: IQuickBookingV2CustomerItem[]) => (data: ICustomerItemData | null) => void;
  onValidateChooseCustomer?: (newData: ICustomerItemData, oldData?: IQuickBookingV2CustomerItem[]) => boolean;
};

const CustomerDataItem = ({ onValidateChooseCustomer, onChangeCustomer, single, getListStaff, staffs, index, value, name, modalChangeTimeRef, changeServiceModalRef, onActiveService, onOpenChangeStaff }: CustomerDataItemProps) => {
  const form = Form.useFormInstance();
  const handleValidateChooseCustomer = (newData: ICustomerItemData) => {
    if (!onValidateChooseCustomer) return true;
    return onValidateChooseCustomer(newData, form.getFieldValue('customerList'));
  };

  return (
    <>
      <Container>
        {!single && <Box display='flex' flexDirection='column' gap='1' mb='2'>
          <div className="label-section">Customer #{index + 1}</div>
          {/* <Form.Item name={[name, 'name']} noStyle>
            <InputCustomerName />
          </Form.Item> */}
          <Form.Item name={[name, 'customer']} noStyle>
            <CustomerSearchInput
              v2NewApt
              preventUnknown
              autoOpenAddWhenNotFound
              v2
              useForService
              onChange={value && onChangeCustomer?.(value, form.getFieldValue('customerList'))}
              validate={handleValidateChooseCustomer}
            />
          </Form.Item>
        </Box>}
        <Box display='flex' flexDirection='column' gap='1'>
          {!single && <div className="label-services">Please select the services</div>}
          <Box display='flex' flexDirection='column' gap='2'>
            <Form.Item noStyle name={[name, 'services']}>
              <CustomerServiceList
                modalChangeTimeRef={modalChangeTimeRef} name={name}
                changeServiceModalRef={changeServiceModalRef}
                onActiveService={onActiveService}
                staffs={staffs}
                getListStaff={getListStaff}
                customerId={value?.id || ''}
                onOpenChangeStaff={onOpenChangeStaff}
              />
            </Form.Item>
          </Box>
        </Box>
      </Container>
    </>
  );
};

export { CustomerDataItem };
type InputCustomerNameProps = {
  value?: string;
  onChange?: (value?: string) => void;
};
const InputCustomerName = ({ value, onChange }: InputCustomerNameProps) => {
  return (
    <>
      <InputCustomerNameStyled display='flex' alignItems='center' gap='2'>
        <Input value={value} onChange={(e: any) => onChange?.(e.target.value)} suffix={<button className='btn-clear' type='button' onClick={() => onChange?.('')}><span>clear</span></button>} />
      </InputCustomerNameStyled>
    </>
  );
};
const InputCustomerNameStyled = styled(Box)`
  position: relative;
  z-index: 1;
  span.label, .ant-input {
    color: #505050;
    font-family: Poppins;
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: 137.5%;
    letter-spacing: 0.36px;
  }
  .ant-input-affix-wrapper {
    padding: 0;
    overflow: hidden;
    border-radius: 4px;
    border: 1px solid #86909C;
    background: #FFF;
    .ant-input-suffix {
      align-self: stretch;
      button.btn-clear {
        align-self: stretch;
      }
    }
    .ant-input {
      display: flex;
      padding: 0px;
      padding-left: 16px;
      align-items: center;
      align-self: stretch;
    }
  }
  .label {
    position: absolute;
    z-index: 2;
    top: 50%;
    left: 8px;
    transform: translateY(-50%);
  }
  button.btn-clear {
    display: flex;
    padding: 0px 24px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 4px;
    background: #C6E9EF;
    span {
      color: #1D2129;
      text-align: center;
      font-family: Poppins;
      font-size: 20px;
      font-style: normal;
      font-weight: 600;
      line-height: normal;
    }
  }
`;


const Container = styled(Box)`
display: flex;
flex-direction: column;
margin-bottom: 16px;

.label-section {
  color: #1D2129;
  font-family: Poppins;
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
.label-services {
  color: #64748B;
  font-family: Poppins;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
`;

const CustomerInfo = styled.button`
display: flex;
align-items: center;
gap: 8px;
height: 32px;
.label, .edit-text {
  color: #505050;
  text-align: center;
  font-family: Poppins;
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: 137.5%;
  letter-spacing: 0.36px;
}
  
.edit-text {
  color: #2D6772;
  font-size: 20px;
}

`;
